import type { ReactNode } from 'react'

import { useState } from 'react'

import { HeaderNavigation } from '@/components/ui'
import { useNavigate } from 'react-router-dom'

interface HeaderProps {
  children?: ReactNode
}

export default function Header({ children }: HeaderProps) {
  const [title,] = useState<String>("Kitchen Mix")
  const navigate = useNavigate()

  const navigateToHome = (event: React.MouseEvent | React.TouchEvent) => {
    if (event.preventDefault) {
      event.preventDefault()
    }

    navigate('/home')
  }

  return (
    <header className="fixed top-0 z-10 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 safe-area-padding-top">
      {children || (
        <div className="w-full max-w-[768px] mx-auto flex h-16 items-center justify-between px-4">
          <div className="flex items-center">
            <h1 className="cursor-pointer text-xl font-bold text-foreground" onClick={navigateToHome}>{title}</h1>
          </div>

          <HeaderNavigation />
        </div>
      )}
    </header>
  )
}
